import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=0e6ecd0e"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e6ecd0e')) {
      api.createRecord('0e6ecd0e', component.options)
    } else {
      api.reload('0e6ecd0e', component.options)
    }
    module.hot.accept("./SidebarItem.vue?vue&type=template&id=0e6ecd0e", function () {
      api.rerender('0e6ecd0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin/views/layout/components/Sidebar/SidebarItem.vue"
export default component.exports